import Checkout from "../components/checkout.vue";
import Vue from "vue";
import i18n from '../plugins/i18n';

Number.prototype['clamp'] = function (min, max) {
    return Math.min(Math.max(this, min), max);
};

export const elementInViewport = (el) => {
    let rect = el.getBoundingClientRect();

    return rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */;
};

export const convertModelToFormData = (model: any, form = null, namespace = '') => {
    let formData = form || new FormData();
    let formKey;

    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || !model[propertyName]) continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date)
            formData.append(formKey, model[propertyName]);
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                convertModelToFormData(element, formData, tempFormKey);
            });
        } else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
            convertModelToFormData(model[propertyName], formData, formKey);
        else
            formData.append(formKey, model[propertyName]);
    }
    return formData;
};

export const isBrowser = () => {
    return typeof window != "undefined";
};

export const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop;
};

export const setCookie = (name, value, days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

export const appendDiv = (name) => {
    let div = document.createElement('div');

    div.id = name;
    div.classList.add(name);
    document.body.appendChild(div);
};

export const mount = (component, selector, obj: any = {}) => {
    let element = document.querySelector(selector);

    if (!element) return console.error("Can't find element", selector);

    if (!obj.replace) {
        let div = document.createElement('div');

        element.appendChild(div);

        element = div;
    }

    new Vue({
        data: obj.data || {},
        i18n,
        render: h => h(component),
    }).$mount(element);
};

export const openCheckout = () => {
    if(!document.querySelector('#L2Tcheckout')) {
        appendDiv('L2Tcheckout')
    }

    mount(Checkout, '#L2Tcheckout', {
        data: {
            standalone: true,
        }
    });
};

export const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export const deleteCookie = (name) => {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const serializeObject = (obj) => {
    let str = '';

    Object.keys(obj).forEach((key) => {
        if (str.length != 0) {
            str += '&'
        }
        str += `${key}=${obj[key]}`
    });

    return str;
};

export const canIUseStyle = (style) => {
    return style in document.body.style;
};


export const parseUrl = (str, seperator = '?') => {
    let objStr = str.split(seperator)[1],
        obj = {};

    if (objStr) {
        objStr.split("&").forEach((item) => {
            let split = item.split("=");

            obj[split[0]] = split[1];
        });
    }

    return obj;
};

export const toDecimal = (num) => {
    return parseFloat(num).toFixed(2).replace('.', ',');
};

export const isMobileLandscape = () => {
    return window.innerWidth <= 768;
};

export const getRandomInt = (min, max) => {
    return Math.floor((Math.random() * max) + min);
};

export const isSafari = () => {
    return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf('CriOS') == -1 &&
        navigator.userAgent.indexOf('FxiOS') == -1;
};

export const isIE = () => {
    return navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
};

export const generateUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const round = (num, closest) => {
    return Math.round(num / closest) * closest;
};
